<template>
  <div class="form container-empresa-form">
    <p><strong>Formulário para abertura de empresas</strong></p>
    
    <br/>
    
    <div id="container-empresa" :class="{'is-preview': preview}">
      <TrfInput
        label="Nome fantasia"
        placeholder="Nome fantasia"
        margin="0"
        id="processo-form-empresa-nomefantasia"
        v-model="formData.nomeFantasia"
        maxLength="50"
        ref="campoEmpresaNomeFantasia"
        v-e2e="'nomeFantasia-empresa-processo'"
        :required="false"
      ></TrfInput>
       <br/>
      <p><strong>Indique abaixo 3 sugestões de nomes para a empresa.</strong></p>
      <br/>
      <TrfInput
        class="mb-3"
        label="Nome empresarial (Sugestão 1)"
        placeholder="Primeiro nome sugerido"
        margin="0"
        id="processo-form-empresa-nomefantasia1"
        v-model="formData.nomeEmpresarial1"
        maxLength="50"
        ref="campoEmpresaNomeEmpresarial1"
        v-e2e="'nomeEmpresarial1-empresa-processo'"
        :required="false"
      ></TrfInput>
      <TrfInput
      class="mb-3"
        label="Nome empresarial (Sugestão 2)"
        placeholder="Segundo nome sugerido"
        margin="0"
        id="processo-form-empresa-nomefantasia2"
        v-model="formData.nomeEmpresarial2"
        maxLength="50"
        ref="campoEmpresaNomeEmpresarial2"
        v-e2e="'nomeEmpresarial2-empresa-processo'"
        :required="false"
      ></TrfInput>
      <TrfInput
        label="Nome empresarial (Sugestão 3)"
        placeholder="Terceiro nome sugerido"
        margin="0"
        id="processo-form-empresa-nomefantasia3"
        v-model="formData.nomeEmpresarial3"
        maxLength="50"
        ref="campoEmpresaNomeEmpresarial3"
        v-e2e="'nomeEmpresarial3-empresa-processo'"
        :required="false"
      ></TrfInput>
      <br/>
      <TrfFormularioBaseEndereco
        @update:form-data="(formData) => setEndereco(formData)"
        id="processo-form-empresa-endereco"
        ref="campoEmpresaEndereco"
      >
        <template #titulo>
          <p><strong>Qual o endereço da empresa?</strong></p>
        </template>
      </TrfFormularioBaseEndereco>
      <TrfNumberInput
        label="Qual o número do IPTU da empresa?"
        placeholder="IPTU da empresa"
        margin="0"
        id="processo-form-empresa-iptu"
        v-model="formData.iptuEmpresa"
        maxLength="20"
        ref="campoEmpresaIPTU"
        v-e2e="'numeroIPTU-empresa-processo'"
        :required="false"
      ></TrfNumberInput>
      <br/>
      <p><strong>Dados complementares</strong></p>
      <br/>
      <div class="columns is-2 mb-0">
        <div class="column is-narrow">
          <TrfNumberInput
            label="Quantos sócios?"
            placeholder="Digite"
            margin="0"
            id="processo-form-empresa-quantidadedesocios"
            v-model="formData.quantidadeDeSocios"
            maxLength="2"
            max="99"
            min="1"
            ref="campoEmpresaQuantidadeDeSocios"
            :required="false"
            :hasMarginBottomLabel="true"
            v-e2e="'qntSocios-empresa-processo'"
          ></TrfNumberInput>
        </div>
        <div class="column is-narrow">
          <TrfInputValor
            label="Qual o valor do capital social?"
            placeholder=""
            id="processo-form-empresa-capitalsocial"
            @update:model-value="setCapitalSocial"
            ref="campoEmpresaCapitalSocial"
            v-e2e="'capitalSocial-empresa-processo'"
          ></TrfInputValor>
        </div>
        <div class="column">
          <TrfInputValor
            label="Qual a estimativa de faturamento mensal?"
            placeholder=""
            id="processo-form-empresa-faturamentomensal"
            @update:model-value="setFaturamentoMensal"
            ref="campoEmpresaFaturamentoMensal"
            v-e2e="'faturamentoMensal-empresa-processo'"
            :shouldBreakLine="false"
          ></TrfInputValor>
        </div>
      </div>
    </div>
    
    <br/>
    
    <div id="container-listagem-socios"  :class="{'is-preview': preview && !isVisualizacao}">
      <TrfListagemDeSociosCadastro
        :listagem-de-socios="listagemDeSocios"
        :preview="preview"
        :isVisualizacao="isVisualizacao"
        :showMaisAcoes="showMaisAcoesSocios"
        ref="listagemSociosEmpresa"
      ></TrfListagemDeSociosCadastro>
    </div>
    
    <br/>
    
    <div id="container-anexo"  :class="{'is-preview': preview}">
      <p><strong>Insira uma cópia do(s) documento(s)</strong></p>
      <br/>
      <p><strong>Anexos</strong></p>
      <TrfButtonUpLoadAttachment
        tipLabel="Extensões permitidas: *.bmp, *.doc, *.dot, *.jpg, *.pdf, *.png, *.xls, *.odt, *.odf, *.rtf, *.txt, *.xml, *.html, *.gif, *.zip, *.rar, *.xlsx, *.docx, *.ppt, *.pptx, *.7z, *.jpeg, *.htm, *.csv, *.qrp, *.tdm, *.ofx, *.ofc."
        @uploadFile="doUploadAnexo"
        @onDrop="doUploadAnexo"
        ref="campoEmpresaAnexo"
      >
      </TrfButtonUpLoadAttachment>
      <TrfListagemDeAnexosCadastro v-if="hasAnexos"
        :listagem-de-anexos="formData.anexos"
        :acoes="acoesAnexo"
        @elegalize-remover-anexo="removerAnexo"
        ref="listagemAnexosEmpresa"
      >
      </TrfListagemDeAnexosCadastro>
    </div>
  </div>
</template>
  <script>
  import { defineAsyncComponent } from 'vue';
  import { ToastBuilder, toastTypeEnum } from '../../../../builder/toast.builder.js';
  import DadosEmpresa from '../Models/dados-empresa.model.js';
  
  export default {
    name: 'TrfEmpresaFormularioBase',
    expose: ['inicializarCampos', 'limparCampos', 'validacoes'],
    components: {
      TrfInput: defineAsyncComponent(() => import('../../../../components/Input/index.vue')),
      TrfInputValor: defineAsyncComponent(() => import('../../../../components/Input/InputValor.vue')),
      TrfNumberInput: defineAsyncComponent(() => import('../../../../components/Input/TrfNumberInput.vue')),
      TrfFormularioBaseEndereco: defineAsyncComponent(() => import('../../../../components/FormularioBaseEndereco/index.vue')),
      TrfListagemDeSociosCadastro: defineAsyncComponent(() => import('./ListagemDeSociosCadastro.vue')),
      TrfButtonUpLoadAttachment: defineAsyncComponent(() => import('../../../../components/ButtonUpload/TrfButtonUpLoadAttachment.vue')),
      TrfListagemDeAnexosCadastro: defineAsyncComponent(() => import('./ListagemDeAnexosCadastro.vue'))
    },
    emits: ['elegalize-iniciar-formulario-socio', 'update:form-data', 'elegalize-editar-formulario-socio', 'elegalize-editar-formulario-socio'],
    props: {
      listagemDeSocios: {
          type: Array,
          default: new Array(),
          required: false
      },
      acoesAnexo: {
        type: Array,
        default: () => ['excluir']
      },
      preview: {
        type: Boolean,
        default: false,
        required: false
      },
      isVisualizacao: {
        type: Boolean,
        default: false,
        required: false
      },
      showMaisAcoesSocios: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        formData: new DadosEmpresa(),
        loadings: {
          anexo: {}
        }
      };
    },
    computed: {
      validacoes() {
        const cepValido = this.$refs.campoEmpresaEndereco.$refs.campoEnderecoCep.verificarSeInputEValido();
        return {
          form: cepValido,
          campos: {
            cep: cepValido
          }
        };
      },
      hasAnexos() {
        return this.formData && this.formData.anexos && Array.isArray(this.formData.anexos) && this.formData.anexos.length;
      }
    },
    watch: {
      formData: {
        immediate: true,
        handler() {  
          this.$emit('update:form-data', this.formData)
        },
        deep: true
      },
      listagemDeSocios: {
        immediate: true,
        handler() {
          this.formData.socios = [...this.listagemDeSocios];
        },
        deep: true
      },
    },
    methods: {
      async getFileUtils() {
        const { fileUtils } = await import('../../../../util/file.utils.js');
        return fileUtils;
      },
      inicializarCampos(dados) {
        this.formData.updateDados(dados);
        this.$refs.campoEmpresaCapitalSocial.inicializarInput(this.formData.capitalSocial);
        this.$refs.campoEmpresaFaturamentoMensal.inicializarInput(this.formData.faturamentoMensal);
        this.$refs.campoEmpresaEndereco.inicializarCampos(dados.endereco);
      },
      setLoading(chave, valor) {
        if (!chave || !this.loadings[chave] || !valor) return;
        this.loadings[chave] = valor;
      },
      setEndereco(formData) {
        this.formData.endereco.updateDados(formData);
      },
      setCapitalSocial(valor) {
        this.formData.capitalSocial = valor;
      },
      setFaturamentoMensal(valor) {
        this.formData.faturamentoMensal = valor;
      },
      setNomeFantasia(valor) {
        this.formData.nomeFantasia = valor;
      },
      setNomeEmpresarial1(valor) {
        this.formData.nomeEmpresarial1 = valor;
      },
      setNomeEmpresarial2(valor) {
        this.formData.nomeEmpresarial2 = valor;
      },
      setNomeEmpresarial3(valor) {
        this.formData.nomeEmpresarial3 = valor;
      },
      async doUploadAnexo(event) {
        if (this.preview) return;
        this.loadings.anexo = true;

        const files = event.target.files;
        const novosAnexos = [];

        const errors = [];

        const fileUtils = await this.getFileUtils();

        for await (const arquivo of Array.from(files)) {
          let base64 = await fileUtils.converterArquivoParaBase64(arquivo);
          base64 = base64.split(",")[1];

          const [, extensao] = fileUtils._splitNomeExtensao(arquivo.name);

          let anexo = {
            nome: arquivo.name,
            extensao,
            mime: arquivo.type,
            size: arquivo.size,
            bytes: base64,
          };

          if(anexo.size > fileUtils._converteMbParabyte(fileUtils.ANEXO_SIZE_LIMIT)) {
            errors.push(`Arquivo ${anexo.nome} excede o limite máximo permitido de ${fileUtils.ANEXO_SIZE_LIMIT} MB!`);
            continue;
          }
          if(!fileUtils._isExtensaoValida(anexo.extensao)) {
            errors.push(`Arquivo ${anexo.nome} tem uma extensão não permitida!`);
            continue;
          }
          novosAnexos.push(anexo);
        }
        if (errors.length > 0) {
          errors.forEach(e => this.callToast(e, toastTypeEnum.DANGER));
        }

        const anexosExistentes = Array.isArray(this.formData.anexos)? this.formData.anexos : []
        
        this.formData.updateDados({anexos: [...anexosExistentes, ...novosAnexos]})
        
        this.loadings.anexo = false;
      },
      removerAnexo(index) {
        this.formData.anexos.splice(index, 1)
      },
      async callToast(message, type, duration = 5000) {
        if (!message) return;
        new ToastBuilder()
            .setType(type)
            .setDuration(duration)
            .setMessage(message)
            .toast();
      },
      limparCampos() {
        this.formData = new DadosEmpresa();
        this.$refs.campoEmpresaNomeFantasia.limparInput();
        this.$refs.campoEmpresaNomeFantasia.limparValidacao();
        this.$refs.campoEmpresaNomeEmpresarial1.limparInput();
        this.$refs.campoEmpresaNomeEmpresarial1.limparValidacao();
        this.$refs.campoEmpresaNomeEmpresarial2.limparInput();
        this.$refs.campoEmpresaNomeEmpresarial2.limparValidacao();
        this.$refs.campoEmpresaNomeEmpresarial3.limparInput();
        this.$refs.campoEmpresaNomeEmpresarial3.limparValidacao();
        this.$refs.campoEmpresaEndereco.limparCampos();
        this.$refs.campoEmpresaIPTU.limparInput();
        this.$refs.campoEmpresaIPTU.limparValidacao();
        this.$refs.campoEmpresaQuantidadeDeSocios.limparInput();
        this.$refs.campoEmpresaQuantidadeDeSocios.limparValidacao();
        this.$refs.campoEmpresaCapitalSocial.clear();
        this.$refs.campoEmpresaFaturamentoMensal.clear();
      }     
    },
    mounted() {}
  };
  </script>
  <style lang="scss" scoped>
  .is-preview {
    pointer-events: none;
    cursor: default!important;
    * {
      pointer-events: none;
      cursor: default!important;
    }
  }
  .multiselect-econtador {
    margin: 0;
  }
  .columns.is-0 > .column, .columns.is-gapless > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 {
  margin-left:-0.25em;
  margin-right:-0.25em;
 & > .column {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  } 
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}
  </style>
  